import React from 'react';

import Group from '@lightspeed/cirrus-group';
import Modal, { ModalBody, ModalFooter, ModalHeader } from '@lightspeed/cirrus-modal';
import Text, { TextContent } from '@lightspeed/cirrus-text';
import { Button } from '@lightspeed/flame/Button';
import PropTypes from 'prop-types';

import Localize from 'app/src/localize/Localize';
import { createReactRenderer } from 'helpers/react-renderer';

class PreauthInventoryWarningDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: true,
      isRemoving: false,
    };

    this.handleClose = this.handleClose.bind(this);
    this.handleRemoveItems = this.handleRemoveItems.bind(this);
  }

  handleClose() {
    const { onClose } = this.props;

    this.setState(
      {
        isOpen: false,
      },
      onClose
    );
  }

  handleRemoveItems() {
    const { onRemoveItems } = this.props;

    this.setState({ isRemoving: true }, () => {
      onRemoveItems();
    });
  }

  render() {
    const { isOpen, isRemoving } = this.state;

    return (
      <Modal className="cirrus responsive" isOpen={isOpen} onRequestClose={this.handleClose}>
        <ModalHeader onCloseClicked={this.handleClose}>
          {Localize.translate("Preauthorization doesn't support inventory items yet")}
        </ModalHeader>
        <ModalBody>
          <TextContent>
            <Text bodySmall>
              {Localize.translate(
                'Preauthorization only works with non-inventory items or miscellaneous sale lines.'
              )}
            </Text>
          </TextContent>
        </ModalBody>
        <ModalFooter>
          <Group className="cr-justify-end">
            <Button onClick={this.handleClose} disabled={isRemoving}>
              {Localize.translate('Close')}
            </Button>
            <Button
              variant="danger"
              fill
              onClick={this.handleRemoveItems}
              loading={isRemoving}
              disabled={isRemoving}
            >
              {Localize.translate('Remove inventory items')}
            </Button>
          </Group>
        </ModalFooter>
      </Modal>
    );
  }
}

PreauthInventoryWarningDialog.propTypes = {
  onClose: PropTypes.func,
  onRemoveItems: PropTypes.func,
};

PreauthInventoryWarningDialog.defaultProps = {
  onClose: () => {},
  onRemoveItems: () => {},
};

// eslint-disable-next-line
let _preauthInventoryWarningDialog = null;

/**
 * Shows the preauth inventory warning dialog.
 *
 * @param {Object} options - Dialog options
 * @param {Function} options.onClose - Callback when the dialog is closed without action
 * @param {Function} options.onRemoveItems - Callback when the user chooses to remove inventory items
 */
export const showPreauthInventoryWarningDialog = ({
  onClose = () => {},
  onRemoveItems = () => {},
}) => {
  const RenderedComponent = createReactRenderer({
    component: PreauthInventoryWarningDialog,
    selector: '[data-react-root="ReactModal"]',
    props: {
      onClose: () => {
        onClose();
        _preauthInventoryWarningDialog = null;
        RenderedComponent.unmount();
      },
      onRemoveItems: () => {
        onRemoveItems();
        _preauthInventoryWarningDialog = null;
        RenderedComponent.unmount();
      },
    },
  });
  _preauthInventoryWarningDialog = RenderedComponent.mount();
};

export default PreauthInventoryWarningDialog;
